var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAlphanumeric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lucide / delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 5.41667C10.295 5.4167 9.77597 5.61713 9.37733 5.97892L2.522 12.1972C2.41011 12.2988 2.3207 12.4226 2.25952 12.5608C2.19834 12.6989 2.16673 12.8484 2.16673 12.9995C2.16673 13.1506 2.19834 13.3 2.25952 13.4381C2.3207 13.5763 2.41011 13.7001 2.522 13.8017L9.37733 20.0211C9.77597 20.3829 10.295 20.5833 10.8333 20.5833H21.6667C22.2413 20.5833 22.7924 20.3551 23.1987 19.9487C23.6051 19.5424 23.8333 18.9913 23.8333 18.4167V7.58333C23.8333 7.0087 23.6051 6.4576 23.1987 6.05127C22.7924 5.64494 22.2413 5.41667 21.6667 5.41667H10.8333Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 9.75L19.5 16.25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 9.75L13 16.25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAlphanumeric);
export default __webpack_public_path__ + "static/media/delete-alphanumeric.9b63530457b48a394b2359eddc79bb36.svg";
export { ForwardRef as ReactComponent };